/* This is not an Environment variable because backstage's Env API does not exist at this level 
and there is no other way to grab this directly from .env files */

export const OKTA_ISSUER = 'https://wildlifestudios.okta.com/oauth2/default';
export const OKTA_CLIENT_ID = '0oa9lz6rdqd8XS6t14x7';
